import React from 'react'
import 'aos/dist/aos.css';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import floorplan1 from '../../assets/images/floorplan/pon floor2 (1).jpeg';
import floorplan2 from '../../assets/images/floorplan/pon floor2 (2).jpeg';
import floorplan3 from '../../assets/images/floorplan/pon floor2 (3).jpeg';
import floorplan4 from '../../assets/images/floorplan/pon floor2 (4).jpeg';

const images = [
  { url: "https://www.gphomes.in/static/media/floorplan2.f56b6cd7b63cf3708171.jpeg", title: 'image' },
  { url: "https://www.gphomes.in/static/media/ponbhoomi%20floorplan2.fca8e30738bbddb1fde3.jpg", title: 'image' },
  { url: "https://www.gphomes.in/static/media/ponbhoomi%20floorplan1.d15ddc5a8b896a4f89af.jpeg", title: 'image' },
  { url: floorplan1, title: '24 / 7 Security Service' },
  { url: floorplan2, title: 'Grand Entrance arch' },
  { url: floorplan3, title: 'EB Provided' },
  { url: floorplan4, title: 'Portable Ground Water' },
];

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
    slidesToSlide: 1, // Slide one item at a time
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
    slidesToSlide: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    slidesToSlide: 1,
  },
};
const VillaGallery = () => {
  return (
    <section className="home-gallery pt-5">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 col-md-10 col-lg-8 text-center" data-aos="fade-up">
            <h3 className="display-6 fw-bold">
              Villa <span className="underline-slide">Construction Progress</span>
            </h3>
          </div>
        </div>
      </div>

      <div style={{ maxWidth: '1200px', margin: '50px auto' }}>
        <Carousel
          responsive={responsive}
          infinite={true}
          autoPlay={true}
          autoPlaySpeed={3000}
          keyBoardControl={true}
          containerClass="carousel-container"
          itemClass="carousel-item-padding-40-px"
          removeArrowOnDeviceType={[]}
        >
          {images.map((img, index) => (
            <div key={index} style={{ padding: '10px', boxSizing: 'border-box' }}>
              <div
                style={{
                  width: '100%',
                  height: '250px', // Landscape-style height
                  position: 'relative',
                  borderRadius: '10px',
                  overflow: 'hidden',
                }}
              >
                <img
                  src={img.url}
                  alt={`Gallery Image ${index + 1}`}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                  }}
                />
              </div>
            </div>
          ))}
        </Carousel>
      </div>
    </section>
  )
}

export default VillaGallery